// File: FashionDesignerAboutSection.jsx
// Pure CSS | Elegant Fashion Styling + Stats Diamonds

import { Droplets, Lightbulb, Medal, Scissors, Shield, Weight } from 'lucide-react';
import React from 'react';

export default function AboutUsCard11() {
  return (<>
    <section className="fd-wrap-ac-11">
      <div className="fd-left-ac-11">
        <h5 className="sub-ac-11">10 Year Experience</h5>
        <h2 className="title-ac-11">ABOUT US</h2>
        <div className="decor-ac-11"></div>

        <p className="text-ac-11">
          Te obtinuit ut adepto satis somno. Aliisque institoribus iter deliciae vivet vita. Nam
          exempli gratia, quotiens ego vadam ad diversorum peregrinorum in mane ut effingo ex
          contractus.
        </p>

        <div className="fd-icon-ac-11s-ac-11">
          <div className="icon-ac-11-item">
            <div className="icon-ac-11"><Droplets size={20} color={`#222222`} /></div>
            <span>Top 10 Coat</span>
          </div>
          <div className="icon-ac-11-item">
            <div className="icon-ac-11"><Medal size={20} color={`#222222`} /></div>
            <span>Winning Awards</span>
          </div>
          <div className="icon-ac-11-item">
            <div className="icon-ac-11"><Scissors size={20} color={`#222222`} /></div>
            <span>Brand Design</span>
          </div>
          <div className="icon-ac-11-item">
            <div className="icon-ac-11"><Lightbulb size={20} color={`#222222`} /></div>
            <span>Great Idea</span>
          </div>
        </div>

        <button className="fd-btn-ac-11">View All About Us</button>
      </div>

      <div className="fd-right-ac-11">
        <div className="law-ac-11-right">
        <h3>Why Choose Us</h3>

        <div className="law-ac-11-features">
          <div className="f-item-ac-11">
            <div className="ficon-ac-11"><Weight size={23} color={`rgba(144, 202, 249,1)`} /></div>
            <div>
              <strong>My Title</strong>
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text.</p>
            </div>
          </div>

          <div className="f-item-ac-11">
            <div className="ficon-ac-11"><Shield size={23} color={`rgba(144, 202, 249,1)`} /></div>
            <div>
              <strong>My Title</strong>
              <p>It has roots in a piece of classical Latin literature from 45 BC.</p>
            </div>
          </div>

          <div className="f-item-ac-11">
            <div className="ficon-ac-11"><Medal size={23} color={`rgba(144, 202, 249,1)`} /></div>
            <div>
              <strong>My Title</strong>
              <p>It has survived not only five centuries, but also the leap into electronic typesetting.</p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
    <style>{`
/* File: FashionDesignerAboutSection.css */


/* Right Card */
.law-ac-11-right {
  background: rgba(144, 202, 249,0.1);
  padding: 30px;
  border-radius: 10px;
  color: #fff;
  position: relative;
}

.law-ac-11-right h3 {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 26px;
  color: rgba(144, 202, 249,1);
}

.law-ac-11-features {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.f-item-ac-11 {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}

.ficon-ac-11 {
  width: 40px;
  height: 40px;
  background: rgba(144, 202, 249,0.21);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: rgba(144, 202, 249,1);
}

.f-item-ac-11 strong {
  font-size: 16px;
  color: #222222;
}

.f-item-ac-11 p {
  font-size: 14px;
  color: #aaa;
  margin-top: 4px;
  max-width: 260px;
  line-height: 1.6;
}

.fd-wrap-ac-11 {margin-top:50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px 0px 60px;
  background: #f3f3f3;
  font-family: Inter, sans-serif;
}

.fd-left-ac-11 { max-width: 540px;flex:1 }
.fd-right-ac-11 {  flex:0.4}
.sub-ac-11 {
  text-ac-11-transform: uppercase;
  font-size: 14px;
  opacity: 0.8;
  margin-bottom: 6px;
}
.title-ac-11 {
  font-size: 38px;
  font-weight: 800;
  margin: 0 0 12px;
  color: #111;
}

.decor-ac-11 {
  width: 60px;
  height: 6px;
  background: rgba(144, 202, 249,1);
  margin-bottom: 20px;
  border-radius: 4px;
}

.text-ac-11 {
  font-size: 15px;
  line-height: 1.7;
  color: #444;
  margin-bottom: 24px;
}

/* ICON ROW */
.fd-icon-ac-11s-ac-11 {
  display: flex;
  gap: 26px;
  margin: 30px 0;
}
.icon-ac-11-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #222;
}

.icon-ac-11 {
  width: 56px;
  height: 56px;
  border: 2px dashed #090909;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

/* BUTTON */
.fd-btn-ac-11 {
  background: rgba(144, 202, 249,1);
  border: none;
  padding: 12px 22px;
  border-radius: 6px;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}

/* RIGHT IMAGE */
.fd-right-ac-11 .designer-img {
  width: 360px;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
}

@media(max-width:960px){
  .fd-wrap-ac-11 {
    flex-direction: column; padding: 70px 10px ;
    text-ac-11-align: center;
  }
    
.ficon-ac-11 {
  width: 40px;padding: 5px 12px;
  height: 40px;
 
}
  .fd-left-ac-11 {padding: 0px 10px 20px;
    max-width: 100%;
  }
  .fd-icon-ac-11s-ac-11 {
    flex-wrap: wrap;
    justify-content: center;
  }
  .fd-right-ac-11 .designer-img {
    margin-top: 30px;
  }
}
`}</style>
  </>);
}
